export { pickLocaleName } from '@/shared/lib/localized-text';

export function formatPrice(minPriceUsd: number | null): string {
  if (minPriceUsd != null) {
    return `$${minPriceUsd.toLocaleString()}~`;
  }
  return '상담 후 협의';
}
